import type { BeautyPlanPrices, PublicPricingCard } from "../types/pricing";

export const beautyPlanPrices: BeautyPlanPrices = {
  solo: 49.9,
  team: 119.9,
  studio: 249.9,
  studioPlus: 399.9
};

export function formatCurrencyBRL(value: number) {
  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function getAnnualPlanTotal(monthlyPrice: number) {
  return Math.round(monthlyPrice * 10);
}

export function getAnnualPlanSavings(monthlyPrice: number) {
  return Math.round(monthlyPrice * 2);
}

export function getMonthlyEquivalentPrice(monthlyPrice: number, isAnnual: boolean) {
  return isAnnual ? (monthlyPrice * 10) / 12 : monthlyPrice;
}

// Fonte temporaria para a vitrine publica enquanto o catalogo comercial ainda nao vem da API.
// A regra canonica continua sendo price book versionado por vertical no backend/billing.
export const beautyPublicPricingCards: PublicPricingCard[] = [
  {
    id: "beauty-solo",
    label: "Beauty · Solo",
    priceLabel: `R$ ${formatCurrencyBRL(beautyPlanPrices.solo)}`,
    periodLabel: "/mês",
    description: "Para profissionais individuais que precisam parar de operar no improviso.",
    features: ["1 profissional", "Agendamento online", "Agenda interna operacional", "Histórico de clientes"],
    href: "/beauty",
    ctaLabel: "Conhecer Beauty"
  },
  {
    id: "beauty-team",
    label: "Beauty · Team",
    priceLabel: `R$ ${formatCurrencyBRL(beautyPlanPrices.team)}`,
    periodLabel: "/mês",
    description: "Para salões com até 3 profissionais e visão unificada da equipe.",
    features: ["Até 3 profissionais", "Agenda por profissional", "Painel de equipe", "Base para evolução operacional"],
    href: "/go/start",
    ctaLabel: "Começar",
    variant: "featured"
  },
  {
    id: "beauty-studio-assisted",
    label: "Beauty · Studio e Studio+",
    priceLabel: "Sob consulta",
    description: "Operações maiores entram com apoio comercial e configuração orientada quando fizer sentido.",
    features: ["Capacidade ampliada", "Entrada assistida", "Evolução sem trocar de produto"],
    href: "/go/start",
    ctaLabel: "Falar com o THH GO",
    variant: "assisted"
  }
];
